export const mockedPraxisMixedItemDistribution = {
	data: {
		contents: [
			{
				id: 783,
				collectionId: 783,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 3,
				},
				totalCount: 3,
				type: "QUESTION_SET",
				isPremium: null,
			},
			{
				id: 784,
				collectionId: 784,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				totalCount: 7,
				type: "QUESTION_SET",
				isPremium: null,
			},
			{
				id: 785,
				collectionId: 785,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 9,
				},
				totalCount: 9,
				type: "QUESTION_SET",
				isPremium: null,
			},
			{
				id: 786,
				collectionId: 786,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				totalCount: 7,
				type: "QUESTION_SET",
				isPremium: null,
			},
			{
				id: 787,
				collectionId: 787,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				totalCount: 7,
				type: "QUESTION_SET",
				isPremium: null,
			},
			{
				id: 788,
				collectionId: 788,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				totalCount: 7,
				type: "QUESTION_SET",
				isPremium: null,
			},
			{
				id: 789,
				collectionId: 789,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 5,
				},
				totalCount: 5,
				type: "QUESTION_SET",
				isPremium: null,
			},
			{
				id: 790,
				collectionId: 790,
				collectionType: "STANDARD_MODULE",
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 11,
				},
				totalCount: 11,
				type: "QUESTION_SET",
				isPremium: null,
			},
		],
		accuracy: 0,
		speed: 0,
		tags: [
			{
				id: 37087,
				label: "Module 1: Professional Ethics for Educators",
				title: "Module 1: Professional Ethics for Educators",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 103622,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103626,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103625,
						variant: "MCQ",
						stats: null,
					},
				],
				numItems: 3,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 3,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
			{
				id: 37088,
				label: "Module 2: The Professional Educator",
				title: "Module 2: The Professional Educator",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 103628,
						variant: "SATA",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103646,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103649,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103627,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103644,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103647,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103648,
						variant: "MCQ",
						stats: null,
					},
				],
				numItems: 7,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
			{
				id: 37089,
				label: "Module 3: The Professional Educator and the Student",
				title: "Module 3: The Professional Educator and the Student",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 103671,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103674,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103673,
						variant: "SATA",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103676,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103651,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103669,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103678,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103677,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103653,
						variant: "SATA",
						stats: null,
					},
				],
				numItems: 9,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 9,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
			{
				id: 37090,
				label: "Module 4: The Professional Educator and the School",
				title: "Module 4: The Professional Educator and the School",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 103699,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103698,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103701,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103696,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103687,
						variant: "SATA",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103682,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103704,
						variant: "MCQ",
						stats: null,
					},
				],
				numItems: 7,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
			{
				id: 37091,
				label: "Module 5: The Professional Educator and the Community",
				title: "Module 5: The Professional Educator and the Community",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 103722,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103721,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103708,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103720,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103724,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103725,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103711,
						variant: "SATA",
						stats: null,
					},
				],
				numItems: 7,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
			{
				id: 37092,
				label: "Module 6: The Professional Educator and Technology",
				title: "Module 6: The Professional Educator and Technology",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 103747,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103733,
						variant: "SATA",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103746,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103748,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103749,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103734,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103742,
						variant: "MCQ",
						stats: null,
					},
				],
				numItems: 7,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 7,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
			{
				id: 37093,
				label: "Module 7: The Professional Educator and AI",
				title: "Module 7: The Professional Educator and AI",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 104840,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 104841,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 104842,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 104843,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 104844,
						variant: "MCQ",
						stats: null,
					},
				],
				numItems: 5,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 5,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
			{
				id: 37094,
				label:
					"Module 8: Ethical Decision Making for the Professional Educator",
				title:
					"Module 8: Ethical Decision Making for the Professional Educator",
				type: "Learning Module",
				code: null,
				weight: 0,
				icon: null,
				displayType: ["Display", "Filter", "Progress"],
				numCorrect: 0,
				numIncorrect: 0,
				numSkipped: 0,
				numPointsEarned: 0,
				numTotalPoints: 0,
				items: [
					{
						distribution: "none",
						type: "question",
						id: 103758,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103761,
						variant: "SATA",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103765,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103766,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103768,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103763,
						variant: "SATA",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103759,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103752,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103754,
						variant: "SATA",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103770,
						variant: "MCQ",
						stats: null,
					},
					{
						distribution: "none",
						type: "question",
						id: 103767,
						variant: "MCQ",
						stats: null,
					},
				],
				numItems: 11,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 11,
				},
				children: [],
				averageScore: 0,
				examName: "Educator Ethics Assessment",
			},
		],
		numPointsEarned: 0,
		numTotalPoints: 0,
		freeTagIds: [],
		exams: [
			{
				id: "Module 1: Professional Ethics for Educators",
				title: "Module 1: Professional Ethics for Educators",
				collectionId: 783,
				testFormat: null,
				hasAccess: false,
				type: "SUMMATIVE",
				subType: "PRACTICE_TEST",
				beginStartDate: null,
				endStartDate: null,
				legacyReport: null,
				migratedSessionReport: null,
				numItems: 0,
				numericId: null,
				numCompleted: 0,
				status: "NOT_STARTED",
				time: null,
				timeElapsed: 0,
				totalTime: 14000,
				attempted: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				dateCompleted: null,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				createdAt: null,
				updatedAt: null,
				examName: "Educator Ethics Assessment",
			},
			{
				id: "Module 2: The Professional Educator",
				title: "Module 2: The Professional Educator",
				collectionId: 784,
				testFormat: null,
				hasAccess: false,
				type: "SUMMATIVE",
				subType: "PRACTICE_TEST",
				beginStartDate: null,
				endStartDate: null,
				legacyReport: null,
				migratedSessionReport: null,
				numItems: 7,
				numericId: null,
				numCompleted: 0,
				status: "NOT_STARTED",
				time: null,
				timeElapsed: 0,
				totalTime: 14000,
				attempted: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				dateCompleted: null,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				createdAt: null,
				updatedAt: null,
				examName: "Educator Ethics Assessment",
			},
			{
				id: "Module 3: The Professional Educator and the Student",
				title: "Module 3: The Professional Educator and the Student",
				collectionId: 785,
				testFormat: null,
				hasAccess: false,
				type: "SUMMATIVE",
				subType: "PRACTICE_TEST",
				beginStartDate: null,
				endStartDate: null,
				legacyReport: null,
				migratedSessionReport: null,
				numItems: 9,
				numericId: null,
				numCompleted: 0,
				status: "NOT_STARTED",
				time: null,
				timeElapsed: 0,
				totalTime: 14000,
				attempted: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				dateCompleted: null,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				createdAt: null,
				updatedAt: null,
				examName: "Educator Ethics Assessment",
			},
			{
				id: "Module 4: The Professional Educator and the School",
				title: "Module 4: The Professional Educator and the School",
				collectionId: 786,
				testFormat: null,
				hasAccess: false,
				type: "SUMMATIVE",
				subType: "PRACTICE_TEST",
				beginStartDate: null,
				endStartDate: null,
				legacyReport: null,
				migratedSessionReport: null,
				numItems: 7,
				numericId: null,
				numCompleted: 0,
				status: "NOT_STARTED",
				time: null,
				timeElapsed: 0,
				totalTime: 14000,
				attempted: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				dateCompleted: null,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				createdAt: null,
				updatedAt: null,
				examName: "Educator Ethics Assessment",
			},
			{
				id: "Module 5: The Professional Educator and the Community",
				title: "Module 5: The Professional Educator and the Community",
				collectionId: 787,
				testFormat: null,
				hasAccess: false,
				type: "SUMMATIVE",
				subType: "PRACTICE_TEST",
				beginStartDate: null,
				endStartDate: null,
				legacyReport: null,
				migratedSessionReport: null,
				numItems: 7,
				numericId: null,
				numCompleted: 0,
				status: "NOT_STARTED",
				time: null,
				timeElapsed: 0,
				totalTime: 14000,
				attempted: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				dateCompleted: null,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				createdAt: null,
				updatedAt: null,
				examName: "Educator Ethics Assessment",
			},
			{
				id: "Module 6: The Professional Educator and Technology",
				title: "Module 6: The Professional Educator and Technology",
				collectionId: 788,
				testFormat: null,
				hasAccess: false,
				type: "SUMMATIVE",
				subType: "PRACTICE_TEST",
				beginStartDate: null,
				endStartDate: null,
				legacyReport: null,
				migratedSessionReport: null,
				numItems: 7,
				numericId: null,
				numCompleted: 0,
				status: "NOT_STARTED",
				time: null,
				timeElapsed: 0,
				totalTime: 14000,
				attempted: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				dateCompleted: null,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				createdAt: null,
				updatedAt: null,
				examName: "Educator Ethics Assessment",
			},
			{
				id: "Module 8: Ethical Decision Making for the Professional Educator",
				title:
					"Module 8: Ethical Decision Making for the Professional Educator",
				collectionId: 790,
				testFormat: null,
				hasAccess: false,
				type: "SUMMATIVE",
				subType: "PRACTICE_TEST",
				beginStartDate: null,
				endStartDate: null,
				legacyReport: null,
				migratedSessionReport: null,
				numItems: 11,
				numericId: null,
				numCompleted: 0,
				status: "NOT_STARTED",
				time: null,
				timeElapsed: 0,
				totalTime: 14000,
				attempted: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				dateCompleted: null,
				distribution: {
					high: 0,
					low: 0,
					medium: 0,
					none: 0,
				},
				createdAt: null,
				updatedAt: null,
				examName: "Educator Ethics Assessment",
			},
		],
		hasAccess: true,
	},
};
